/**
 * 서비스지역 React Query 키 상수.
 *
 * 파라미터 의존 키는 배열에 파라미터를 함께 추가:
 *   queryKey: [SERVICE_AREA_KEYS.REGION_DETAIL, region, subRegion]
 */
export const SERVICE_AREA_KEYS = {
  /** 광역권역 리스트 */
  REGION_LIST: 'service-area-region-list',
  /** 광역권역 상세 (region + subRegion 의존) */
  REGION_DETAIL: 'service-area-region-detail',
  /** 서비스 지역 여부 검증 (address 의존) — 1차 검증 */
  AVAILABILITY: 'service-area-availability',
  /** 오픈 알림 신청 현황 (address 의존) — POST mutation 후 invalidate */
  WAITLIST_STATUS: 'service-area-waitlist-status',
} as const
